import { faBellSlash } from '@fortawesome/pro-regular-svg-icons';
import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { ButtonHTMLAttributes, useMemo, useState } from 'react';
import VoxelIconButton from '../../components/voxel/Buttons/VoxelIconButton';
import VoxelText from '../../components/voxel/Text/VoxelText';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../graphql/projects/projectsApiService';
import { CurrentUserGq } from '../../graphql/users/models/CurrentUserGq';

export interface SubscribeButtonProps
  extends Pick<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  user?: CurrentUserGq;
  project: ProjectGq;
  reload: () => Promise<any>;
}

const SubscribeButton: React.FC<SubscribeButtonProps> = ({ onClick, user, project, reload }) => {
  // Progress tracking - Subscribe
  const subscribed = useMemo(
    () => user.projectSubscriptions.some((p) => p === project.id),
    [user, project.id]
  );
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const subscribeMutation = projectsApiService.mutations.projects.useSubscribeToProject();
  const handleSubscribe = () => {
    if (subscribeLoading) return;
    setSubscribeLoading(true);
    subscribeMutation({ projectId: project.id, on: !subscribed })
      .then(() => reload())
      .finally(() => setSubscribeLoading(false));
  };

  return (
    <div className="flex flex-row items-center gap-2 ">
      <VoxelIconButton
        icon={<FontAwesomeIcon icon={subscribed ? faBell : faBellSlash} />}
        color={subscribed ? 'success' : 'gray'}
        tooltip={`Enable notifications when there is new data (${subscribed ? 'ON' : 'OFF'})`}
        onClick={handleSubscribe}
      />
    </div>
  );
};

export default SubscribeButton;
